import { gql, useMutation } from '@apollo/client';
import type { Popup, PopupVariant } from '@shady-pines/db';
import type { Timestamp, Url } from '@shady-pines/types';
import { useCallback } from 'react';
import type { MutationResponse } from '../types';

const CREATE_POPUP_MUTATION = gql`
  mutation CreatePopup($objects: [popupsInsertInput!]!) {
    insertIntopopupsCollection(objects: $objects) {
      records {
        __typename
        id
        title
        description
        expires_at
        active_at
        enabled
        variant
        external_url
      }
    }
  }
`;

type CreatePopupInput = {
  title: string;
  description: string;
  expires_at: Timestamp;
  active_at: Timestamp;
  enabled: boolean;
  variant: PopupVariant;
  external_url: Url | null;
};

export const useCreatePopup = () => {
  const [createPopupMutation, { loading, error }] =
    useMutation<MutationResponse<'insertIntopopupsCollection', Popup>>(CREATE_POPUP_MUTATION);

  const create = useCallback(
    async (input: CreatePopupInput) => {
      return createPopupMutation({
        variables: {
          objects: [input],
        },
      });
    },
    [createPopupMutation],
  );

  return {
    createPopup: create,
    loading,
    error,
  };
};
